/** Tiny classnames joiner shared by the UI primitives. Not part of the public `@/components/ui` API. */
export type ClassValue = string | number | false | null | undefined;

export const cx = (...values: ClassValue[]): string => values.filter(Boolean).join(' ');
